import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ComicRecommendGrid from './components/ComicRecommendGrid';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫在线',
  url: 'http://wxctif.com/',
  description: '韩漫在线观看，免费下拉式漫画阅读平台。提供韩国漫画全集在线阅读，高清画质和流畅阅读体验。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://wxctif.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫在线',
  url: 'http://wxctif.com/',
  description: '专业韩国漫画在线阅读平台',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '望京SOHO T1座1206室',
    addressLocality: '北京',
    addressRegion: '北京市',
    addressCountry: 'CN',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-888-6666',
    contactType: 'customer service',
  },
  sameAs: ['http://wxctif.com/'],
};

export default function Home() {
  return (
    <>
      <SEOHead
        schema={[homeSchema, orgSchema]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ComicRecommendGrid />
        <AboutSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}